"use strict";

angular.module("vendor")
.service("CustomerToApproveService", function(
    $resource, FlashBag, gettextCatalog, common, PartnershipSelectorUnregisteredServiceFactory, appConfig
) {
    const LISTING_URL = "/auth/vendor/partnerships/list/";
    const URL_PARAMS = {to_approve: 1};

    function CustomerToApproveService() {
        PartnershipSelectorUnregisteredServiceFactory.call(this, LISTING_URL, URL_PARAMS);

        this.getBulkActionParams = function() {
            var approveResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/approval/approve/", {}, {
                query: {
                    method: "GET",
                    isArray: true,
                    interceptor: {responseError: FlashBag.responseErrorInterceptor}
                },
                save: {
                    method: "POST",
                    interceptor: {responseError: FlashBag.responseErrorInterceptor}
                }
            });

            var rejectResource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/approval/reject/", {}, {
                query: {
                    method: "GET",
                    isArray: true,
                    interceptor: {responseError: FlashBag.responseErrorInterceptor}
                },
                save: {
                    method: "POST",
                    interceptor: {responseError: FlashBag.responseErrorInterceptor}
                }
            });

            return {
                approve: {
                    text: gettextCatalog.getString("Approve"),
                    message: gettextCatalog.getString("Do you really want to approve these customers?"),
                    successMessage: gettextCatalog.getString("Customers were approved successfully."),
                    resource: approveResource,
                    modalTemplatePrefix: "partnership",
                    modalTemplatePackage: "vendor"
                },
                reject: {
                    text: gettextCatalog.getString("Reject"),
                    message: gettextCatalog.getString("Do you really want to reject these customers?"),
                    resource: rejectResource,
                    successMessage: gettextCatalog.getString("Customers were rejected successfully."),
                    modalTemplatePrefix: "partnership",
                    modalTemplatePackage: "vendor"
                }
            };
        };

        this.getSingleActionParams = function() {
            return this.getBulkActionParams();
        };

        this.getSortFields = function() {
            return common.getSortFieldsByKeys(
                "company_name, buyer_number",
                this.getAvailableSortFields()
            );
        };

    }

    return new CustomerToApproveService();
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/customer-to-approve.service.js
// module id = 868
// module chunks = 0